import request from "@/utils/axios";
const baseURL = process.env.VUE_APP_CHART_API

// 轮播图模块
// PC
export function getSwiperList() {
	return request({
		baseURL: baseURL,
		path: "/swiper/getSwiperList",
	});
}

// 移动端
export function getMobileSwiperList() {
	return request({
		baseURL: baseURL,
		path: "/moveSwiper/getMoveSwiperList",
	});
}


// 电影模块
export function getMovieList(data) {
	return request({
		baseURL: baseURL,
		path: "/movie/getMovieList",
		data
	});
}


// 动态管理模块
export function getManagementList(data) {
	return request({
		baseURL: baseURL,
		path: "/management/getManagementList",
		data
	})
}

// 背景图
export function getBackgroundImg() {
	return request({
		baseURL: baseURL,
		path: "/backgroundImg/getBackgroundImg"
	})
}

